import { useEffect, useState } from 'react';

const stats = [
  { icon: '🏷️', label: 'COMMITMENT', value: 'Best Prices' },
  { icon: '🌿', label: 'CERTIFIED', value: 'FSSAI Licensed' },
  { icon: '🚚', label: 'CONVENIENCE', value: 'Home Delivery' },
  { icon: '📞', label: 'SUPPORT', value: 'Always Available' },
];

export default function Hero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  return (
    <section id="home" className="text-white pt-44 md:pt-48 pb-20 px-6 md:px-20">
      <div className="grid md:grid-cols-2 gap-12 items-center">

        {/* LEFT */}
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>

          <div className="bg-red-900/40 border border-red-700/40 text-red-300 px-4 py-2 inline-flex items-center gap-2 rounded-full mb-6 text-sm">
            <span className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></span>
            🛒 Nashik's Premier Neighbourhood Store
          </div>

          <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
            We Ensure You Always Get The{' '}
            <span className="text-red-500">Freshest Products</span>{' '}
            at the Best Prices
          </h1>

          <p className="text-gray-400 mb-8 leading-relaxed text-lg">
            Galaxy Super Market brings quality groceries, fresh produce, dairy, and daily essentials right to your doorstep across Nashik — trusted by thousands of families in Chetana Nagar and beyond.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://wa.me/919623969912"
              className="bg-red-500 hover:bg-red-600 transition px-7 py-3 rounded-full font-semibold flex items-center justify-center gap-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp Us Now
            </a>
            <a
              href="#services"
              className="border border-gray-600 hover:border-red-500 hover:text-red-400 transition px-7 py-3 rounded-full font-semibold flex items-center justify-center gap-2"
            >
              Explore Our Range →
            </a>
          </div>
        </div>

        {/* RIGHT */}
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
          <div className="bg-zinc-900/80 border border-zinc-800 p-6 rounded-2xl shadow-2xl">

            <div className="flex items-center gap-3 pb-4 mb-4 border-b border-zinc-700">
              <img src="/logo.png" alt="logo" className="w-12 rounded-lg" />
              <div>
                <div className="font-bold text-white">Galaxy Super Market</div>
                <div className="text-gray-400 text-sm">Why shop with us?</div>
              </div>
            </div>

            {stats.map((s, i) => (
              <div key={i} className={`flex items-center gap-4 py-3 ${i < stats.length - 1 ? 'border-b border-zinc-800' : ''}`}>
                <div className="w-10 h-10 bg-red-900/50 border border-red-800/50 rounded-xl flex items-center justify-center text-lg">
                  {s.icon}
                </div>
                <div>
                  <div className="text-xs text-gray-500 tracking-widest font-semibold">{s.label}</div>
                  <div className="font-bold text-white">{s.value}</div>
                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
}